import Cookie from 'js-cookie';

import 'source/global';
import {
    loadCommonMenu,
    loadFavicons,
    loadSchemaScript,
    loadGtm,
    loadLanguage,
    loadScript,
    loadStyle,
    loadVwo,
    loadCookieBanner,
} from 'source/lib/loaders';

import Settings from 'source/lib/settings_model';

import { _ } from 'wgnet-awesomejs';
import FooterView from './parts/footer';
import IDRouter from './router';

function isAuthenticated() {
    const cookieName = Settings.get('App.IsAuthenticatedCookieName');
    return Cookie.get(cookieName) === 'yes';
}

function pushSpaIdToGtm() {
    window.dataLayer = window.dataLayer || [];
    const spaID = Settings.get('Request.AccountInfo.AccountSPA.Id', null);

    window.dataLayer.push({
        spaID: _.isNull(spaID) ? spaID : spaID.toString(),
        visitorType: _.isNull(spaID) ? 'Not authorized' : 'Authorized',
    });
}

async function initialize() {
    await Settings.startSync();
    document.documentElement.lang = Settings.get('General.LanguageCode');

    await Promise.all([
        loadScript(`${Settings.get('App.StaticUrl')}l10n/plugins/moment/moment.js`)
            .catch(() => {
                window.moment = () => ({
                    format() {
                        return '';
                    },
                });
            })
            .then(() => loadLanguage()),
        loadCommonMenu(),
        loadFavicons(Settings.get('App.StaticUrl')),
        loadSchemaScript(Settings.get('App.StaticUrl')),
        loadStyle(Settings.get('App.StaticUrl'),
            Settings.get('Realm.FeatureRealm') || Settings.get('Realm.CurrentRealm')),
    ]);

    await loadCookieBanner();
    loadVwo();

    if (Settings.get('App.EnableGtmSpaId')) {
        pushSpaIdToGtm();
    }
    loadGtm(Settings.get('General.GoogleTagManager'), isAuthenticated());

    document.querySelector('#common_menu').classList.remove('hidden');

    const stagingInfo = Settings.get('Request.StagingInfo');
    const stagingInfoElement = document.querySelector('#staging-info');
    const logoLink = document.querySelector('.js-header-content a');

    if (stagingInfo) {
        stagingInfoElement.innerHTML = stagingInfo;
    }
    logoLink.setAttribute('href', Settings.get('Realm.UrlLogoLink'));

    document.querySelector('.js-header').style.display = '';
    const router = new IDRouter();

    const footerView = new FooterView({
        el: '#js-footer',
        router,
    });
    return { router, footerView };
}

import('wg-riddler' /* webpackChunkName: "riddler" */)
    .then(module => {
        window.Riddler = module.default;
        return initialize();
    }).catch(
        (err) => {
            console.error(err);
        },
    );
